import { resolvePath, formatString, formatUrl, isFunction, setScrollPosition, isRelativeURL, isArray } from '@config/utils';
import { CheckPermission } from './acls';
import ValidateMixin from './ValidateMixin';
import MessageMixin from './MessageMixin';
import theme from './theme';

export default {
    props: {
        // moduleCode passed by route
        // moduleCode: {
        //     type: String,
        //     default: null
        // },
    },
    data() {
        return {
            fromRoute: null,
            pageTitle: '',
            addTitle: 'Adicionar',
            updateTitle: 'Atualizar',
            configTitle: 'Configurar',
            submitTitle: 'Salvar',
            cancelTitle: 'Cancelar',
            deleteTitle: 'Remover',
            searchPlaceholder: 'global.placeholder-search',
            noResults: 'Sem Resultados',
            btnBackTitle: 'Voltar',
            btnSaveTitle: 'Salvar',
            btnPrintTitle: 'Imprimir',
            notFoundMsg: 'Sem resultados'
        };
    },
    mixins: [
        ValidateMixin,
        theme,
        CheckPermission,
        MessageMixin,
    ],
    mounted() {
        if (this.$route.meta.title) {
            let title = this.$route.meta.title;
            let i8nTitle = this.$t(title);
            this.pageTitle = i8nTitle == title ? title : i8nTitle;
        }
        this.hideTooltip();
        this.activeTooltip();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fromRoute = from;
        });
    },
    // beforeRouteLeave(to, from) {
    //     console.log('beforeRouteLeave')
    //     this.$store.dispatch('breadcrumbChanged', undefined);
    //     return true;
    // },
    computed: {
        initialPagePlatform() {
            return this.$root.$env.FIRST_COMPONENT.name;
        },
        maxUploadSize() {
            return this.$root.$env.UPLOAD_MAX;
        },
    },
    methods: {
        setScrollPosition(position) {
            let route = this.$route;
            const scrollPos = position || route.meta?.scrollPos || { x: 0, y: 0 };
            setScrollPosition(scrollPos, route.hash, this.$root);
        },
        checkPermissionPanel: function (panel, key) {
            if (panel) {
                return !!(panel ? panel.active && (!panel.acl || (panel.acl && this.$auth.check(panel.acl))) : false);
            }
            return false;
        },
        handleBack(fallback, force = false) {
            if (fallback && (!this.fromRoute || !this.fromRoute.name || force)) {
                if (this.$route?.name != fallback) {
                    this.$router.push({ name: fallback });
                }
            } else {
                this.$router.back();
            }
        },
        clearMessages: function () {
            this.$root.$helper.messages.removeToast();
        },
        showHttpError: function (error) {
            this.$root.$helper.error.httpError(error);
            if (this.$root.$env.DEBUG) {
                console.error(error);
            }
        },
        showInfo: function (message, title = this.pageTitle, callbackClose = () => {}, timeout = 5000) {
            this.showMessage(message, title, 'info', callbackClose, timeout);
        },
        showWarning: function (message, title = this.pageTitle, callbackClose = () => {}, timeout = 5000) {
            this.showMessage(message, title, 'warning', callbackClose, timeout);
        },
        showError: function (message, title = this.pageTitle, callbackClose = () => {}, timeout = 5000) {
            this.showMessage(message, title, 'error', callbackClose, timeout);
        },
        showMessage: function (message, title = this.pageTitle, type = 'success', callbackClose = () => {}, timeout = 5000) {
            this.$root.$helper.messages.showToast(this.$t(message), this.$t(title), type, callbackClose, timeout);
        },
        activeTooltip(boundary = 'window') {
            this.$nextTick(function () {
                this.$root.$helper.global.hideTooltip();
                this.$root.$helper.global.activeTooltip(boundary);
            });
        },
        hideTooltip() {
            this.$nextTick(function () {
                this.$root.$helper.global.hideTooltip();
            });
        },
        getFormatUrlAPI(path) {
            return this.$root.$helper.global.formatUrlAPI(path);
        },
        resetUrlAPI(url) {
            return this.$root.$helper.global.resetUrlAPI(url);
        },
        verifyMaxUploadSize(size) {
            return size && size / 1024 / 1024 > this.maxUploadSize;
        },
        getMinPasswordLength() {
            return this.$root.$helper.global.getMinPasswordLength();
        },
        assetsPathTheme: function (target) {
            return this.$root.$helper.theme.assetsPathTheme(target);
        },
        assetsPathGlobal: function (target) {
            return this.$root.$helper.theme.assetsPathGlobal(target);
        },
        assetsPathModule: function (target) {
            return this.$root.$helper.theme.assetsPathModule(this.moduleCode || this.moduleInternalCode, target);
        },
        assetsPathGlobalPlatform: function (target) {
            return this.$root.$helper.platform.assetsPathGlobalPlatform(target);
        },
        assetsPathModulePlatform: function (target) {
            return this.$root.$helper.platform.assetsPathModulePlatform(this.moduleCode || this.moduleInternalCode, target);
        },
        resolvePath(obj, path) {
            return resolvePath(obj, path);
        },
        formatString(string, values, prefixPlaceholder = ":", suffixPlaceholder ='') {
            return formatString(string, values, prefixPlaceholder, suffixPlaceholder);
        },
        formatUrl(url, values, prefixPlaceholder = ":", suffixPlaceholder ='') {
            return formatUrl(url, values,prefixPlaceholder, suffixPlaceholder);
        },
        columnValue(obj, column, field = undefined, onlyVal = false) {
            let val = this.resolvePath(obj, field ? field : column.field_label || column.field);
            val = isFunction(column.func) ? column.func(val, obj) : val;
            if (!onlyVal && column.tooltip) {
                let tooltip = this.resolvePath(obj, column.tooltip);
                if (tooltip) {
                    return `<span data-toggle="tooltip-city" data-placement="top" title="${tooltip}">${val}</span>`;
                }
            }
            return val;
        },
        columnStatus(obj, column, status = ['fas fa-check', 'fas fa-ban'], css = ['text-success', 'text-warning']) {
            let val = this.columnValue(obj, column);
            let icon = !!val ? `${status[0]} ${css[0]}` : `${status[1]} ${css[1]}`;
            return `<i class="${icon}"></i>`;
        },
        columnOnOff(obj, column, labels = ['global.true', 'global.false']) {
            let val = this.columnValue(obj, column);
            return this.$t(!!val ? `${labels[0]}` : `${labels[1]}`);
        },
        convertHex: function (color) {
            return this.$root.$helper.color.convertHex(color);
        },
        getRouterLinkFromPage: function (item, params = {}, urlProperty = 'url') {
            let routeName = 'portal.pages';
            let url = item && urlProperty in item ? item[urlProperty] : null;
            if (url) {
                let router = this.$router;
                url = url.toLocaleLowerCase();
                if (isRelativeURL(url)) {
                    const { route } = router.resolve({ path: url });
                    if (route) {
                        routeName = route.name;
                    }
                } else {
                    const resolve = router.resolve({ path: '/' });
                    const basePath = new URL(resolve.href, window.location.origin).href.toLocaleLowerCase();
                    if (url.startsWith(basePath)) {
                        const path = url.replace(basePath.replace(/\/$/, ''), '');
                        const { route } = router.resolve({ path });
                        if (route) {
                            routeName = route.name;
                        }
                    }
                }
            }

            return {
                name: routeName,
                params
            };
        },
        getAutocompleteOptions(url, model, params = {}) {
            return {
                ...{
                    url: formatUrl(url, { model, id: params?.id ?? '' }),
                    loadOnFocusIfEmpty: true,
                    allowClear: true,
                    idType: 'number',
                    fieldLabel: `name`,
                    placeholder_label: `global.placeholder-autocomplete-select`
                },
                ...params
            };
        },
        publishEventListen(moduleCode, event) {
            if(isArray(event)) {
                event.forEach(item => this.publishEventListen(moduleCode, item));
            } else {
                this.$eventBus.publish(moduleCode, event);
            }
        },
        addEventListen(moduleCode, event, callback) {
            if(isArray(event)) {
                event.forEach(item => this.addEventListen(moduleCode, item, callback));
            } else {
                this.$eventBus.listen(moduleCode, event, callback);
            }
        },
        removeEventListen(moduleCode, event, callback) {
            if(isArray(event)) {
                event.forEach(item => this.removeEventListen(moduleCode, item, callback));
            } else {
                this.$eventBus.remove(moduleCode, event, callback);
            }
        }
    }
};
